<script setup lang="ts">
import { Image } from '@unpic/vue'
import { computed, inject } from 'vue'

import { appConfigProviderKey } from '../../constants'
import type { ProcessableImage } from '../../types/common.types'

const props = withDefaults(
  defineProps<{
    image: ProcessableImage
    width: number | string
    height: number | string
    alt: string
    layout?: 'constrained' | 'fullWidth' | 'fixed'
    quality?: number
    skipWidth?: boolean
    skipHeight?: boolean
    objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
    resizeType?: 'fill' | 'fit' | 'fill-down' | 'force' | 'auto'
    mediaBaseUrl?: string
  }>(),
  { layout: 'constrained', quality: 90, resizeType: 'fill', objectFit: 'cover' },
)

const emits = defineEmits(['onLoadError'])
const config = inject<{ mediaBaseUrl: string }>(appConfigProviderKey)

const mediaBaseUrl = computed(() => config?.mediaBaseUrl || props.mediaBaseUrl)

const imageUrlTransformer = ({ width = 0, height = 0 }) =>
  `${mediaBaseUrl.value}/_/rs:${props.resizeType}:${props.skipWidth ? 0 : width}:${props.skipHeight ? 0 : height}/g:sm/q:${props.quality}/${props.image.key}`
</script>

<template>
  <Image
    v-if="image?.key && mediaBaseUrl"
    :layout="layout"
    :width="width"
    :height="height"
    :transformer="imageUrlTransformer"
    :src="image.key"
    :object-fit="objectFit"
    :alt="alt"
    @error="emits('onLoadError')"
  />
  <img v-else-if="image?.url" :src="image.url" :width="width" :height="height" :alt="alt" @error="emits('onLoadError')" />
</template>
